const storagePrefix = "on_us_user";

const storage = {
  getToken: () => {
    const val = window.localStorage.getItem(`${storagePrefix}token`) ?? "";
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
};

export default storage;
